module.exports = __webpack_public_path__ + "static/img/Victor-Radley.85d94bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Victor-Radley.jpg
// module id = a+iN
// module chunks = 0